import { useApiClient } from '@chilipiper/api-client/src/context'
import {
  SanitizedAssigneeSelection,
  ScheduleMeetingRequestPublic,
} from '@chilipiper/api-client/src/handoff'
import {
  OneClickInitializationRequest,
  ScheduleMeetingRequest,
} from '@chilipiper/api-client/src/team-scheduling'
import { usePublicRoutingInfo } from '@chilipiper/api-queries/src/handoff'
import { useMutation } from '@tanstack/react-query'

export const useBookMeeting = (tenantId: string) => {
  const { teamScheduling } = useApiClient()

  return useMutation({
    mutationFn: (payload: ScheduleMeetingRequest) => {
      return teamScheduling.scheduleAMeetingGuestEndpoint(tenantId, payload)
    },
  })
}

export const useInitializeOneClick = (tenantId: string) => {
  const { teamScheduling } = useApiClient()

  return useMutation({
    mutationFn: async (payload: OneClickInitializationRequest) => {
      const response = await teamScheduling.initializeOneClickSchedulingFormGuestEndpoint(
        tenantId,
        payload
      )

      return response
    },
  })
}

export const useHandoffBooking = (tenantId: string) => {
  const { handoff } = useApiClient()

  return useMutation({
    mutationFn: ({
      routingId,
      params,
    }: {
      routingId: string
      params: ScheduleMeetingRequestPublic
    }) => {
      return handoff.scheduleMeetingWithinAParticularRoutingIdPublic(tenantId, routingId, params)
    },
  })
}

export const useHandoff = (tenantId: string, routingId?: string) => {
  const {
    data: handoffRouting,
    isLoading: isLoadingHandoff,
    refetch: refetchPublicRoutingInfo,
  } = usePublicRoutingInfo(tenantId, routingId)

  const routing =
    handoffRouting?.type === 'PublicRoutingInfoForSelected' ? handoffRouting : undefined
  const distributionId = getDistributionIdFromSelectedAssignee(
    routing?.selectResponse.selectedAssignee
  )

  return {
    handoffRouting: routing,
    distributionId,
    isLoading: !!routingId && isLoadingHandoff,
    refetchPublicRoutingInfo,
  }
}

const getDistributionIdFromSelectedAssignee = (assigneeSelection?: SanitizedAssigneeSelection) => {
  if (
    assigneeSelection?.type === 'FromDistribution' ||
    assigneeSelection?.type === 'UserFromDistribution'
  ) {
    return assigneeSelection.distributionId
  }
  return undefined
}
